import { Fragment } from "react";
import { formatTRY } from "@/lib/format";

const money = (v) => (Math.abs(v) < 0.005 ? "—" : formatTRY(v));

function Row({ r, onCell }) {
  const tone = r.dir === "in" ? "text-emerald-700" : "text-rose-700";
  return (
    <tr data-testid={`cf-row-${r.key}`} className={r.included ? "" : "opacity-40"}>
      <td className="whitespace-nowrap">{r.label}{r.prob_applied && <span className="ml-1 text-[10px] text-amber-700">(olasılık)</span>}<span className="ml-1 text-[10px] text-slate-400">{r.count}</span></td>
      {r.values.map((v, i) => (
        <td key={i} className={`text-right font-mono ${v ? `${tone} cursor-pointer hover:underline` : "text-slate-300"}`} onClick={() => v && onCell(r, i)} data-testid={`cf-cell-${r.key}-${i}`}>{money(r.dir === "out" ? -v : v)}</td>
      ))}
      <td className={`text-right font-mono font-semibold ${tone}`}>{money(r.dir === "out" ? -r.total : r.total)}</td>
      <td className={`text-right font-mono ${r.undated_total ? "cursor-pointer text-slate-700 hover:underline" : "text-slate-300"}`} onClick={() => r.undated_total && onCell(r, "vadesiz")} data-testid={`cf-cell-${r.key}-vadesiz`}>
        {r.undated ? money(r.dir === "out" ? -r.undated_total : r.undated_total) : ""}</td>
    </tr>
  );
}

export default function ForecastTable({ d, onCell }) {
  const groups = [["in", "GİRİŞLER"], ["out", "ÇIKIŞLAR"]];
  return (
    <div className="panel overflow-x-auto">
      <table className="dense-table w-full" data-testid="cf-table">
        <thead><tr><th>Kategori</th>{d.periods.map((p) => <th key={p.start} className="text-right whitespace-nowrap">{p.label}</th>)}<th className="text-right">Toplam</th><th className="text-right">Vadesiz</th></tr></thead>
        <tbody>
          <tr className="bg-slate-50 font-semibold"><td>Açılış bakiyesi</td><td colSpan={d.periods.length} /><td className="text-right font-mono" data-testid="cf-opening-total">{formatTRY(d.opening.total_try)}</td><td /></tr>
          {groups.map(([g, label]) => (
            <Fragment key={g}>
              <tr><td colSpan={d.periods.length + 3} className="pt-3 text-[11px] font-semibold tracking-wide text-slate-500">{label}</td></tr>
              {d.rows.filter((r) => r.dir === g).map((r) => <Row key={r.key} r={r} onCell={onCell} />)}
            </Fragment>
          ))}
          <tr className="border-t-2 font-semibold" data-testid="cf-net-row"><td>Net</td>{d.net.map((v, i) => <td key={i} className={`text-right font-mono ${v < 0 ? "text-rose-600" : "text-emerald-700"}`}>{formatTRY(v)}</td>)}<td className="text-right font-mono">{formatTRY(d.totals.net)}</td><td /></tr>
          <tr className="font-semibold" data-testid="cf-closing-row"><td>Dönem Sonu Bakiye</td>{d.closing.map((v, i) => <td key={i} className={`text-right font-mono ${v < 0 ? "bg-rose-50 text-rose-700" : ""}`} data-testid={`cf-closing-${i}`}>{formatTRY(v)}</td>)}<td className="text-right font-mono">{formatTRY(d.totals.closing)}</td><td /></tr>
        </tbody>
      </table>
    </div>
  );
}
